import { createSlice } from '@reduxjs/toolkit';
export const storeData = async (key, value) => {
	try {
		const jsonValue = JSON.stringify(value);
		sessionStorage.setItem(`${key}`, jsonValue);
	} catch (e) {
		// saving error
	}
};

export const getData = async (key) => {
	try {
		const jsonValue = sessionStorage.getItem(`${key}`);
		return jsonValue != null ? JSON.parse(jsonValue) : null;
	} catch (e) {
		// error reading value
	}
};
const UiReducer = createSlice({
	name: 'ui',
	initialState: {
		tab: 'men',
		modal: false,
	},
	reducers: {
		setTab(state, action) {
			state.tab = action.payload;
		},
		toggleModal(state, action) {
			state.modal = action.payload;
		},
	},
});

const { actions } = UiReducer;

export const { setTab, toggleModal } = actions;

export default UiReducer;
